/**
 * 期货页面
 */

 import React from "react"
 import ReactDOM from "react-dom"
 import { Page_QiHuo } from "../components/page/qihuo";
 
 if(window.quotedata){
   ReactDOM.render(
     <Page_QiHuo quotedata={window.quotedata}/>,
     document.getElementById('app')
   )  
 }
 
 